import { DateTimeField } from "@/src/components";
import {
    AutocompleteInput, BooleanField, BooleanInput, Datagrid, DateField, Filter, List, Pagination,
    ReferenceField, ReferenceInput, TextField
} from "react-admin";

const filters = [
    <ReferenceInput label="user" source="users" reference="user" allowEmpty alwaysOn >
        <AutocompleteInput optionText="profile.nickname" filterToQuery={(txt) => ({ profile: { nickname: txt } })}
            size='small'
        />
    </ReferenceInput>
    ,
    <BooleanInput label="Deleted" source="withDeleted" alwaysOn size='medium' sx={{ padding: "4px" }} />
]

const rowSx = (record: any) => {
    return {
        backgroundColor: record?.deleted && "#e6c8c85b",
    }
}
export const UserLikeMatchList = () => (
    <List
        filters={filters}
        // filter={{ withDeleted: true }}
        sort={{ field: 'createdAt', order: 'DESC' }}
        perPage={100}
        pagination={<UserLikeMatchListPagination />}
        exporter={false}
    >
        <Datagrid
            rowClick="edit" rowSx={rowSx}
            bulkActionButtons={false}
        >
            {/* <TextField source="id" /> */}
            {/* <TextField source="users" /> */}
            <ReferenceField label="User 1" source="users[0]" reference="user">
                <TextField source="profile.nickname" />
            </ReferenceField>
            <ReferenceField label="User 2" source="users[1]" reference="user">
                <TextField source="profile.nickname" />
            </ReferenceField>
            <DateTimeField source="createdAt" />
            <DateTimeField source="updatedAt" />
            <BooleanField source="deleted" />
            <DateField source="deletedAt" />
        </Datagrid>
    </List>
);

const UserLikeMatchListPagination = () => <Pagination rowsPerPageOptions={[50, 100, 200]} />;
